export default "__VITE_ASSET__nghH926q__"